import * as React from 'react';

import { CampaignAIAssistedContextType } from 'types';

const CampaignAIAssistedContext =
  React.createContext<CampaignAIAssistedContextType | null>(null);

const CampaignAIAssistedContextProvider = ({
  currentPhase,
  phaseCustomQuestionGroupName,
  shouldShowAIAssistedQuestionDescriptor,
  children,
}) => {
  const value: CampaignAIAssistedContextType = React.useMemo(
    () => ({
      currentPhase,
      phaseCustomQuestionGroupName,
      shouldShowAIAssistedQuestionDescriptor,
    }),
    [
      currentPhase,
      phaseCustomQuestionGroupName,
      shouldShowAIAssistedQuestionDescriptor,
    ]
  );

  return (
    <CampaignAIAssistedContext.Provider value={value}>
      {children}
    </CampaignAIAssistedContext.Provider>
  );
};

const useCampaignAIAssistedContext =
  (): CampaignAIAssistedContextType | null => {
    return React.useContext(CampaignAIAssistedContext);
  };

export { CampaignAIAssistedContextProvider, useCampaignAIAssistedContext };
